<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
        <!-- 提交按钮 -->
        <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="page.blkTitle.vlan" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="addNewRow" class="btn" style="padding: 0px">
                  <i class="fa fa-plus page-tableaction" title="add"></i>
                </div>
                <div @click="editSelectRow" class="btn" style="padding: 0px">
                  <i class="fa fa-edit page-tableaction" title="edit"></i>
                </div>
                <div @click="delSelectRow" class="btn" style="padding: 0px">
                  <i class="fa fa-trash-o page-tableaction" title="delete"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selall"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in vlanTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in tVlan"
                :key="row.vlanid"
                :class="{
                  info: row.rowStatus === 'new' || row.rowStatus === 'edit',
                  delete: row.rowStatus === 'del',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input type="checkbox" v-model="row.selected" />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in printableRow(row)"
                  :key="key"
                  :title="value"
                >
                  <!-- vlanid 编辑 -->
                  <div v-if="key === 'vlanid' && row.rowStatus === 'new'">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_vlanid_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newvid"
                        class="form-control table-edit"
                        maxlength="4"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_vlanid_check(row) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_vlanid_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_vlanid_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- name 编辑 -->
                  <div
                    v-else-if="
                      key === 'name' &&
                      (row.rowStatus === 'new' || row.rowStatus === 'edit')
                    "
                  >
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_vlanname_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newname"
                        class="form-control table-edit"
                        maxlength="32"
                        placeholder="STRING<1-32>"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{
                          'glyphicon-remove': input_vlanname_check(row),
                        }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_vlanname_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_vlanname_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- member 编辑 -->
                  <div
                    v-else-if="
                      key === 'member' &&
                      (row.rowStatus === 'new' || row.rowStatus === 'edit')
                    "
                  >
                    <span style="position: relative; display: block">
                      <input
                        type="text"
                        v-model="row.newmember"
                        ng-change="input_cg_dest($index)"
                        class="form-control table-edit"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small class="help-block" style="display: none"
                        >The valid port is required</small
                      >
                    </span>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "vlan",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.vlan,
      vlanTable: "",
      tVlan: "",
      selall: false,
      iBox: {},
      newRowCount: 0,
      maxNewRowCount: 5,
      newRow: {
        vlanid: "",
        name: "",
        status: "static",
        member: "",
        statictag: "",
        staticuntag: "",
        dynamictag: "",
        rowStatus: "new",
        newvid: 1,
        newname: "",
        newmember: "",
      },
    }
  },
  created() {
    this.loadvlan()
  },
  methods: {
    loadvlan() {
      get("vlan")
        .then((res) => {
          this.vlanTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面数据初始化 */
    dataInit() {
      this.tVlan = JSON.parse(JSON.stringify(this.vlanTable.data))
      this.tVlan.forEach((element) => {
        this.$set(element, "rowStatus", "")
        this.$set(element, "selected", false)
        this.$set(element, "newvid", 0)
        this.$set(element, "newname", element["name"])
        this.$set(element, "newmember", element["member"])
      })
      this.selall = false
      this.newRowCount = 0
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var newRows = []
      var editRows = []
      var delRows = []
      var vt = this.tVlan
      for (var v = 0; v < vt.length; v++) {
        if (
          vt[v]["rowStatus"] !== "new" &&
          vt[v]["rowStatus"] !== "edit" &&
          vt[v]["rowStatus"] !== "del"
        )
          continue
        if (vt[v]["rowStatus"] === "new" || vt[v]["rowStatus"] === "edit") {
          // 单元参数再次检查
          if (
            (this.input_vlanid_check(vt[v]) && vt[v]["rowStatus"] === "new") ||
            this.input_vlanname_check(vt[v])
          ) {
            this.showAlertBox("warn", "warnning", "Fix the mistake first!")
            return
          }
          // 行内逻辑检查
        }
        // 新行添加冲突检查，编辑行前后对比检查，而后准备数据
        if (vt[v]["rowStatus"] === "new") {
          // 添加新行操作，进行冲突检查
          var skip = false
          for (var d = 0; d < vt.length; d++) {
            if ((d < v && vt[d]["rowStatus"] === "new") || v === d) continue
            // 冲突检查
            if (
              vt[v]["newvid"] ==
              (vt[d]["rowStatus"] === "new" ? vt[d]["newvid"] : vt[d]["vlanid"])
            ) {
              var msg = "VLAN " + vt[v]["newvid"]
              if (vt[d]["rowStatus"] === "new") {
                msg += " repeat add!"
              } else if (vt[d]["rowStatus"] === "del") {
                msg += " add and delete conflicts!"
              } else {
                msg += " already exists!"
              }
              this.showAlertBox("warn", "warnning", msg)
              return
            }
          }
          var row = { vlanid: vt[v]["newvid"] }
          if (vt[v]["newname"] !== this.newRow["newname"])
            row["name"] = vt[v]["newname"]
          if (vt[v]["newmember"] !== this.newRow["newmember"])
            row["member"] = vt[v]["newmember"]
          newRows.push(row)
          // 编辑操作，进行编辑前后变更检查
        } else if (vt[v]["rowStatus"] === "edit") {
          if (
            vt[v]["name"] === vt[v]["newname"] &&
            vt[v]["member"] === vt[v]["newmember"]
          )
            continue
          var row = { vlanid: parseInt(vt[v]["vlanid"]) }
          if (vt[v]["newname"] !== vt[v]["name"]) row["name"] = vt[v]["newname"]
          if (vt[v]["newmember"] !== vt[v]["member"])
            row["member"] = vt[v]["newmember"]
          editRows.push(row)
          // 删除操作
        } else if (vt[v]["rowStatus"] === "del") {
          // 批量操作会导致post数据太长，分段删除
          if (delRows.length === 500) {
            var postDel = {}
            postDel["del"] = delRows
            delRows = []
            post("vlan", postDel)
              .then((res) => {
                if (
                  res.data.code === undefined ||
                  (res.data.code === 0 && res.data.msg === undefined)
                ) {
                  this.showAlertBox("info", "Info", "Config Successful!")
                } else {
                  this.showAlertBox(
                    res.data.code === 0 ? "info" : "warn",
                    res.data.code === 0 ? "Info" : "Warn",
                    res.data.msg !== undefined ? res.data.msg : "Unknow error!"
                  )
                  return
                }
              })
              .catch((err) => {
                this.showAlertBox("critical", "error", err)
                return
              })
          }
          delRows.push({ vlanid: parseInt(vt[v]["vlanid"]) })
        }
      }
      if (!newRows.length && !editRows.length && !delRows.length) {
        this.showAlertBox("info", "info", "Nothing to do!")
        return
      }

      if (delRows.length) postData["del"] = delRows
      if (editRows.length) postData["edit"] = editRows
      if (newRows.length) postData["add"] = newRows

      post("vlan", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config Successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
          this.loadvlan()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 参数输入检查 */
    input_vlanid_check(row) {
      this.$set(row, "newvid", parseInt(row["newvid"]))
      if (isNaN(row["newvid"])) row["newvid"] = 0

      if (row["newvid"] < 1 || row["newvid"] > 4094)
        return "VLAN ID must be between 1-4094."
      return null
    },
    input_vlanname_check(row) {
      if (row["newname"] == row["name"]) return null

      return nonASCIIchar(row["newname"])
    },

    /* 表头添加新行 */
    addNewRow() {
      var vt = this.tVlan
      if (vt.length >= 4094)
        this.showAlertBox("info", "warnning", "Table is full.")
      else if (this.newRowCount >= this.maxNewRowCount)
        this.showAlertBox("info", "warnning", "Too many new row.")
      else {
        vt.unshift(JSON.parse(JSON.stringify(this.newRow)))
        this.newRowCount++
        // 获取新行索引
        var vt1 = JSON.parse(JSON.stringify(vt))
        vt1.sort((a, b) => {
          return a.vlanid - b.vlanid
        })
        for (var vid = 1; vid <= 4094; vid++) {
          if (vt.length <= vid || vid != vt1[vid].vlanid) {
            vt[0].vlanid = vid
            vt[0].newvid = vid
            break
          }
        }
      }
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
        row["selected"] = false
        //row["newname"] = row["name"]
        //row["newmember"] = row["member"]
      }
    },

    /* 编辑选择的行 */
    editSelectRow() {
      var vt = this.tVlan
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
          //element["newname"] = element["name"]
          //element["newmember"] = element["member"]
        }
      })
    },

    /* 删除选择的行 */
    delSelectRow() {
      var vt = this.tVlan
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "del"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      var vt = this.tVlan
      if (row["rowStatus"] === "new") {
        var fi = vt.findIndex((r) => r.vlanid === row.vlanid)
        if (fi !== -1) {
          vt.splice(fi, 1)
          this.newRowCount--
        }
      } else if (row["rowStatus"] === "edit" || row["rowStatus"] === "del") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 行有效打印 */
    printableRow(row) {
      var prow = {}
      for (var c in row) {
        if (
          c === "rowStatus" ||
          c === "selected" ||
          c === "newvid" ||
          c === "newname" ||
          c === "newmember"
        )
          continue
        prow[c] = row[c]
      }
      return prow
    },

    /* 选择全部行 */
    selectall() {
      this.tVlan.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selall
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      /*
      var portMap = [
        { typte: "p", port: "1-16" },
        { typte: "e", port: "1-4" },
        { typte: "e", port: "1-2" },
      ]
      txt = "e1/1-e1/2, d/e, e1/4, e2/1-e2/2, e5/6-e5/2"

      var p = []
      txt
        .replace(/\s+/g, "")
        .split(",")
        .map((v, i) => {
          var range = v.split("-")
          var t1, t2, s1, s2, p1, p2
          t1 = range[0].split("/")
          if (t1.length < 2 || t1[0].length < 2) {
            t1 = t1[0][0]
            s1 = parseInt(t1[0].slice(1))
            if (isNaN(s1)) alert(s1)
          }
          // 不是范围
          if (range.length < 2) {
            return
          }

          t2 = range[0].split("/")
          if (t2.length < 2 || t2[0].length < 2) alert("geshibudui")
        })
*/
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>

